"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _pureReactCarousel = require("pure-react-carousel");

var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery"));

var _styles = require("@material-ui/core/styles");

var _Box = _interopRequireDefault(require("@material-ui/core/Box"));

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _LadderSlide = _interopRequireDefault(require("../LadderSlide"));

var _withSlideCount = _interopRequireDefault(require("../withSlideCount"));

var _SlideshowBack = _interopRequireDefault(require("../SlideshowBack"));

var _SlideshowNext = _interopRequireDefault(require("../SlideshowNext"));

var _useStyle = _interopRequireDefault(require("./useStyle"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var _default = (0, _withSlideCount["default"])(function (_ref) {
  var data = _ref.data,
      visibleSlides = _ref.visibleSlides,
      rest = _objectWithoutProperties(_ref, ["data", "visibleSlides"]);

  var theme = (0, _styles.useTheme)();
  var isBreakpoint = (0, _useMediaQuery["default"])(theme.breakpoints.down('md'));
  var cls = (0, _useStyle["default"])();
  return /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    className: cls.root
  }, /*#__PURE__*/_react["default"].createElement(_pureReactCarousel.CarouselProvider, _extends({
    naturalSlideHeight: "12rem",
    visibleSlides: visibleSlides,
    orientation: isBreakpoint ? 'horizontal' : 'vertical'
  }, rest), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    className: cls.stack,
    container: true
  }, /*#__PURE__*/_react["default"].createElement(_SlideshowBack["default"], {
    className: cls.back
  }), /*#__PURE__*/_react["default"].createElement(_pureReactCarousel.Slider, {
    "aria-label": "Slider container"
  }, data.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement(_LadderSlide["default"], _extends({
      key: index,
      currentSlide: index
    }, item, rest));
  })), /*#__PURE__*/_react["default"].createElement(_SlideshowNext["default"], {
    className: cls.next
  }))));
});

exports["default"] = _default;